///<reference path="../../../typings/bezierplugin/BezierPlugin.d.ts"/>


/**
 * Created by Jerker Nord on 2019-04-16.
 */

export interface ICurvePoints {
    readonly x:number;
    readonly y:number;
}

export interface IBezierThrough {
    readonly y:ISegment[];
    readonly x:ISegment[];
}

export interface ISegment {
    readonly a:number;
    readonly b:number;
    readonly ba:number;
    readonly c:number;
    readonly ca:number;
    readonly d:number;
    readonly da:number;
}

export class GSAPBezierSpline {

    public static interpolate(curvePoints:number[][]):PIXI.Point[] {
        let convertedPoints:ICurvePoints[] = [];
        for(let i:number = 0; i < curvePoints.length; i++) {
            convertedPoints.push({x : curvePoints[i][0], y : curvePoints[i][1]});
        }

        let bezierThrough:IBezierThrough = <IBezierThrough>BezierPlugin.bezierThrough(convertedPoints);

        let points:PIXI.Point[] = [];
        for(let i:number = 0; i < bezierThrough.x.length; i++) {
            let start:PIXI.Point = new PIXI.Point(bezierThrough.x[i].a, bezierThrough.y[i].a);
            let control1:PIXI.Point = new PIXI.Point(bezierThrough.x[i].b, bezierThrough.y[i].b);
            let control2:PIXI.Point = new PIXI.Point(bezierThrough.x[i].c, bezierThrough.y[i].c);
            let end:PIXI.Point = new PIXI.Point(bezierThrough.x[i].d, bezierThrough.y[i].d);
            let t:number = 0;
            while(t < 1.0) {
                points.push(GSAPBezierSpline.interpolateCubicBezier(start, control1, control2, end, t));
                t += 0.02;
            }
            points.push(GSAPBezierSpline.interpolateCubicBezier(start, control1, control2, end, 1));
        }

        return points;
    }

    // B(t) = (1 - t)^3P0 + 3(1 - t)^2tP1 + 3(1 - t)t^2P2 + t^3P3
    private static interpolateCubicBezier(start:PIXI.Point, control1:PIXI.Point, control2:PIXI.Point, end:PIXI.Point, t:number = 0.5):PIXI.Point {
        let point:PIXI.Point = new PIXI.Point();

        point.x = (Math.pow(1 - t, 3) * start.x) +
            (3 * Math.pow(1 - t, 2) * t * control1.x) +
            (3 * (1 - t) * Math.pow(t, 2) * control2.x) +
            (Math.pow(t, 3) * end.x);

        point.y = (Math.pow(1 - t, 3) * start.y) +
            (3 * Math.pow(1 - t, 2) * t * control1.y) +
            (3 * (1 - t) * Math.pow(t, 2) * control2.y) +
            (Math.pow(t, 3) * end.y);

        return point;
    }
}